import { render, staticRenderFns } from "./ItemCategoryTabCategories.vue?vue&type=template&id=b7017e9a&scoped=true&"
import script from "./ItemCategoryTabCategories.vue?vue&type=script&lang=js&"
export * from "./ItemCategoryTabCategories.vue?vue&type=script&lang=js&"
import style0 from "./ItemCategoryTabCategories.vue?vue&type=style&index=0&id=b7017e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7017e9a",
  null
  
)

export default component.exports